// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3o3gN","notes":"Notes_notes__IrUQp"};